export const LOCAL_RECORDING_SLIDES_CANVAS_FPS = 1;
export const LOCAL_RECORDING_SLIDES_PUBLISHING_TIMEOUT = 5;
